<template>
  <a-modal
    :visible="visible"
    :title="title"
    :width="800"
    :forceRender="true"
    @ok="ok"
    @cancel="cancel"
    destroyOnClose
  >

    <h3>
      <span style="font-size: 16px;margin-right: 5px;font-weight: bold;">基础信息</span>
    </h3>
    <a-row :gutter="24">
      <a-col :span="12"><span class="labelTitle">配方代码：</span>{{ detail.formulaCode }}</a-col>
      <a-col :span="12"><span class="labelTitle">配方模型：</span>{{ detail.formulaModelName }}</a-col>
      <a-col :span="12"><span class="labelTitle">动物类型：</span>{{ detail.animalTypeName }}</a-col>
      <a-col :span="12"><span class="labelTitle">盘重：</span>{{ detail.totalWeight }}KG</a-col>
    </a-row>
    <h3 style="margin-bottom: 10px;">
      <span style="font-size: 16px;margin-right: 5px;font-weight: bold;">额外添加</span>
      <a-tooltip>
        <template slot="title">
          额外添加的原料比例≤盘重的5%
        </template>
        <a-icon type="exclamation-circle" />
      </a-tooltip>
    </h3>
    <a-button type="primary" :disabled="isReport" style="margin-bottom: 10px;" @click="openMaterial">导入</a-button>
    <a-table :columns="columns" :scroll="{y:500}" :data-source="totalList" rowKey='rowId' :pagination="false">
      <span v-for="(col) in ['percentage']" slot-scope="text, record" :slot="col" :key="col">
        <cell-editor
          v-if="record.type !== 'last'"
          :background="true"
          :key="col"
          :item="record"
          :len="len"
          :name="col"
          @blur="target => itemUpdate(target,record.id,record,col)"
          :text="text"
          :min="0"
        />
      </span>
      <template slot="uasge" slot-scope="t">
        {{ t || t === 0 ? Number(t).toFixed(len) : '' }}
      </template>
      <template slot="x" slot-scope="t,r,i">
        <a v-if="r.type !== 'last'" @click="() => deleteRow(i)">删除</a>
      </template>
    </a-table>
    <extra-material-list :visible="materialVisible" @close="closeMaterial" :ids="ids" />
  </a-modal>
</template>
<script>
import ExtraMaterialList from './ExtraMaterialList.vue'
import CellEditor from '../editor/CellEditor.vue'
export default {
  props: ['visible','detail'],
  components: {ExtraMaterialList,CellEditor},
  data(){
    return{
      title: <p>额外添加原料<span class='modalTitle'>额外添加的原料不会加入配方成本和营养指标测算</span></p>,
      factoryId: window.localStorage.getItem('factoryId'),
      list: [],
      // totalList: [],
      pagination: {
        total:0,
        pageSize:10000,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      columns: [
        {
          title: '原料名称',
          dataIndex: 'rawName',
          width: 100,
          ellipsis: true,
        },
        {
          title: '原料代码',
          dataIndex: 'rawCode',
          width: 100,
          ellipsis: true,
        },
        {
          title: '类型',
          dataIndex: 'typeName',
          width: 120,
          ellipsis: true,
        },
        {
          title: '用量(%)',
          dataIndex: 'percentage',
          scopedSlots: {customRender: 'percentage'},
          width: 120,
          align: 'center'
        },
        {
          title: '用量(批次量)',
          dataIndex: 'uasge',
          width: 120,
          align: 'center',
          scopedSlots: {customRender: 'uasge'},
        },
        {
          title: '单位',
          dataIndex: 'unit',
          // scopedSlots: {customRender: 'uasge'},
          width: 80,
          ellipsis: true,
        },
        {
          title: '操作',
          dataIndex: 'x',
          scopedSlots: {customRender: 'x'},
          width: 80,
          ellipsis: true,
        },
      ],
      materialVisible: false,
      len: 3
    }
  },
  computed: {
    ids(){
      let ids = this.list.map(el => el.rawId)
      return ids
    },
    totalList(){
      let uasge = 0
      let flag = false
      this.list.forEach(el => {
        uasge += (el.uasge || 0)
        if(el.uasge || el.uasge === 0) flag = true
      })
      uasge = Number(uasge || 0).toFixed(this.len)
      if(!flag) uasge = ''
      let lst = []
      if(this.list.length > 0) lst = [...this.list,{rawName: '合计',uasge,type: 'last'}]
      return lst
    },
    newUasge(){
      let uasge = 0
      this.list.forEach(el => {
        uasge += Number(el.percentage || 0)
      })
      return uasge
    },
    isReport(){
      return this.list.length >= 5
    },
  },
  watch: {
    visible(val){
      if(val) this.getList()
    },
  },
  methods:{
    ok(){
      let formulaRawExtraDTOList = []
      this.list && this.list.forEach(el => {
        formulaRawExtraDTOList.push({
          ...el,formulaId: this.detail.id,
        })
      })
      if(formulaRawExtraDTOList.some(e => !Number(e.percentage))){
        this.$warning({
          title: '操作失败',
          content: '额外添加原料用量必须>0,请调整后再提交。'
        })
        return
      }
      let params = {
        formulaId: this.detail.id,formulaRawExtraDTOList
      }
      this.$http.post('/nhf-app/formularawextra/batchAddFormulaRawExtra',params).then(res => {
        let {success,msg} = res || {}
        if(success) {
          this.$emit('close',true)
        }else{
          this.$message.warning(msg)
        }
      })
    },
    cancel(){
      this.$emit('close')
    },
    getList(){
      let params = {
        formulaId: this.detail.id,
      }
      if(this.detail.id){
        this.$http.get('/nhf-app/formularawextra/getFormulaRawExtraList',{params}).then(res => {
          let {success,data} = res;
          if(success){
            this.list = data
                .filter(item => item.isDeleted !== 1)
                .sort((a, b) => b.percentage - a.percentage);
          }else{
            this.$message.error('查询失败')
          }
        })
      }
    },
    openMaterial(){
      if(this.list.length >= 5){
        this.$message.warning('额外添加原料最多能有5个原料')
        return
      }
      this.materialVisible = true
    },
    closeMaterial(obj){
      if(obj) this.list.push(obj)
      this.materialVisible = false
    },
    deleteRow(i){
      this.$confirm({
        title: '删除',
        content: <p>您确认要删除当前的额外添加原料吗？</p>,
        cancelText:'取消',
        okText:'确定',
        onOk: async () => {
          this.list.splice(i,1)
        },
      })
    },
    itemUpdate(item,id,record,col){
      record[col] = item[col] && Number(item[col]) > 0 ? item[col] : 0
      if(this.newUasge > 5) {
        item[col] = 0
        record[col] = item[col]
        this.$error({
          title: '操作失败',
          content: '额外添加原料重量超过配方盘重的5%，请调整后再提交',
        });
      }
      if(col === 'percentage'){
        record.uasge = (this.detail.totalWeight * record[col] / 100)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.tableBox{
  padding: 0 20px;
}
.labelTitle{
  display: inline-block;
  width: 70px;
  text-align: right;
  line-height: 35px;
}
</style>
